import { useState, useEffect, useMemo, useCallback } from 'react';
import {
  useDocument,
  useUpdates,
  usePending,
  useCanceled,
  useError,
} from '../selectors';
import { getResourceMap } from '../utils/resourceMap';

export function useResponse({ uuid, request, options }) {
  const { action, type } = request;
  const { initialValue, nullValue } = options;
  const [data, setData] = useState(initialValue);

  const jsonapi = useDocument(uuid);
  const updates = useUpdates(uuid);
  const pending = usePending(uuid);
  const canceled = useCanceled(uuid);
  const error = useError(uuid);

  const inflator = useCallback(
    (jsonapi) => getResourceMap(type).inflate(jsonapi, action.verb === 'first'),
    [type, action],
  );

  useEffect(() => {
    if (jsonapi) {
      setData(inflator(jsonapi));
    }
  }, [inflator, jsonapi]);

  useEffect(() => {
    if (canceled) {
      setData(nullValue);
    }
  }, [canceled, nullValue]);

  return useMemo(
    () => ({
      data,
      error,
      updates,
      pending,
      canceled,
      jsonapi,
    }),
    [data, error, updates, pending, canceled, jsonapi],
  );
}
